
import AlertModule from 'vux/src/plugins/alert/module'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default{
data(){
return {
telNum:'',
code: '',
psd: '',
checkPsd:'',
Mbcode:'',
qqNum:'',
show: false,
passShow: false,
passShow1: false,
showPositionValue: false,
position: 'default',
tiptxt:'',
tipType:'',
alertShow : '请填写验证码',
codeSrc : 'https://api.abeiyun.com/www/yzm.php?yzm_type=num&rnd='+Math.random(),
}
},
directives: {
TransferDom
},
mounted(){

},
computed:{

},
methods: {
getCode(){
this.codeSrc = 'https://api.abeiyun.com/www/reg.php?cmd=img_yzm&rnd='+Math.random()
},
showPosition (position) {
this.position = position
this.showPositionValue = true
},
loseB(){
console.log(this.telNum)
console.log(this.Mbcode)
if(this.telNum&&this.Mbcode){

let data ='cmd=check_mobile_yzm&rand='+Math.random()+'&mobile='+this.telNum+'&mobilecode='+this.Mbcode
this.$http.post('https://api.abeiyun.com/www/reg.php',data).then(({data})=>{
this.showPosition('middle')
if(data.result==false){
this.tipType = 'warn'
}
})
}

},
showFlag (){
if(!this.telNum){
this.showPosition('middle')
this.tiptxt = '手机号不能为空';
this.tipType = 'warn'
}else{
this.show = !this.show
}

},
onShow(){
if(!this.telNum){
this.showPosition('middle')
this.tiptxt = '手机号不能为空';
this.tipType = 'warn'
}
},
onHide(){
let data='cmd=send_mobile_yzm&mobile='+this.telNum+'&captcha='+this.code;
this.$http.post('https://api.abeiyun.com/www/reg.php',data).then(({data})=>{
this.showPosition('middle')
this.tiptxt = data.msg;
if(data.response == '200'){
this.tipType = 'success'
}else{
this.tipType = 'warn'
}
})
},
register(){
let data ='cmd=reg&mobile='+this.telNum+'&username='+this.telNum+'&password='+this.psd+'&checkpwd='+this.checkPsd+'&img_yzm='+this.code+'&mobile_yzm='+this.Mbcode;
this.$http.post('https://api.abeiyun.com/www/reg.php',data).then(({data})=>{
this.showPosition('middle')
this.tiptxt = data.msg;
if(data.response== '200'){
this.tipType = 'success';
setTimeout(() => {
this.$router.push('/login');
}, 1600);
}else{
this.tipType = 'warn'
}
})

},
changePassDisplay() {
this.passShow = !this.passShow
},
changePassDisplay1() {
this.passShow1 = !this.passShow1
},

},
components:{

}
}





// WEBPACK FOOTER //
// ./src/components/user/register.vue